import { getApiB2bAccountUserCurrent } from '/api/sdk.gen';

import type { AppDispatch } from '/business/shared/state/store';

interface FetchAuthOptions {
  silent?: boolean;
}

const fetchAuth =
  ({ silent = false }: FetchAuthOptions = {}) =>
  async (dispatch: AppDispatch) => {
    try {
      const sendProps = {
        type: 'FETCH_AUTH_STARTED' as const,
        timestamp: Date.now(),
        silent,
      };

      await dispatch({ ...sendProps });
      const { data: user } = await getApiB2bAccountUserCurrent();

      if (!user) {
        throw new Error('Error fetching authentication data');
      }
      await dispatch({ type: 'FETCH_AUTH_FULFILLED', user, silent });
      return user;
    } catch (error) {
      await dispatch({ type: 'FETCH_AUTH_REJECTED', error });
      throw error;
    }
  };

export default fetchAuth;
